import baseApi from './RootBaseApi';
import {
  NotificationRule,
  NotificationRulesResponse,
  NotificationSettingsModuleListResponse,
} from '@/types/notification-preferences.types';

/**
 * Notification Preferences Service
 * Currently static until API endpoints are finalized.
 */
export const NotificationPreferencesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Placeholders for future integration
    getNotificationModules: builder.query<
      NotificationSettingsModuleListResponse,
      {
        search?: string;
      }
    >({
      query: ({ search } = {}) => ({
        url: 'admin-notification-settings',
        method: 'GET',
        params: {
          search: search || undefined,
          page: 1,
          limit: Number.MAX_SAFE_INTEGER,
        },
      }),
    }),
    getNotificationRules: builder.query<
      NotificationRulesResponse,
      { moduleId: string; search?: string; page?: number; limit?: number }
    >({
      query: ({ moduleId, search, page, limit }) => ({
        url: `admin-notification-settings/${moduleId}/rules`,
        method: 'GET',
        params: {
          search: search || undefined,
          page,
          limit,
        },
      }),
    }),
    updateNotificationRule: builder.mutation<
      NotificationRule,
      {
        id: string;
        body: Partial<
          Pick<
            NotificationRule,
            | 'is_rule_enabled'
            | 'is_email_notification_configured'
            | 'is_push_notification_configured'
            | 'is_email_notification_enabled'
            | 'is_push_notification_enabled'
            | 'user_roles_involved'
          >
        >;
      }
    >({
      query: ({ id, body }) => ({
        url: `admin-notification-settings/${id}`,
        method: 'PATCH',
        data: body,
      }),
    }),
  }),
});

export const {
  useGetNotificationModulesQuery,
  useGetNotificationRulesQuery,
  useUpdateNotificationRuleMutation,
} = NotificationPreferencesService;
